import { render } from "./AsahiArrow.vue?vue&type=template&id=3260a9b7&scoped=true"
import script from "./AsahiArrow.vue?vue&type=script&lang=js"
export * from "./AsahiArrow.vue?vue&type=script&lang=js"

import "./AsahiArrow.vue?vue&type=style&index=0&id=3260a9b7&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3260a9b7"]])

export default __exports__